import { useQuery } from "react-query";
import { getCarrierEAndOData } from "../../../../../actions/CarrierAgreementMgmt/Reports";

const useGetCarrierEandOData = () => {
  return useQuery(["getCarrierEAndOData"], () => getCarrierEAndOData(), {
    refetchOnWindowFocus: false,
  });
};
export default useGetCarrierEandOData;
